import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserInfoSidebarComponent } from './user-info-sidebar.component';
import { SharedModule } from '@shared/shared.module';
import { UserNotesModule } from '../user-notes/user-notes.module';
import { UserActivityModule } from '../user-activity/user-activity.module';
// Note: UserService and UserActivityService are provided in root, so we don't need to import UserModule

/**
 * Standalone UserInfoSidebarModule
 * Can be imported into any module without routing conflicts
 */
@NgModule({
    declarations: [UserInfoSidebarComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        UserNotesModule,
        UserActivityModule
    ],
    exports: [UserInfoSidebarComponent]
})

export class UserInfoSidebarModule { }
